import React, { useState } from "react";
import "./Contact.css";
import { Button, Icon } from "semantic-ui-react";
import ContactForm from "./ContactForm";

const Contact = () => {
  const [contact, setContact] = useState(false);

  const phonePreFix = "tel:";
  const emailPreFix = "mailto:";

  const handleClick = () => {
    if (contact) {
      setContact(false);
    } else {
      setContact(true);

      document.body.style.overflow = "hidden";
    }
  };

  const handleContactClose = () => {
    setContact(false);

    document.body.style.overflow = "unset";
  };

  const contactButton = (
    <div className="ContactButtonContainer">
      <Button icon labelPosition="left" color="blue" onClick={handleClick}>
        <Icon name="paper plane" />
        Contact CSA
      </Button>
    </div>
  );

  return (
    <>
      <div className="ContactBackground">
        <div className="ContactBannerBar"></div>

        <div className="ContactContainer">
          <h1>Contact CSA</h1>
          <div className="ContactImageContainer">
            <img
              src={require("../images/csaContact.png").default}
              alt="contactCsa"
            />
          </div>
          <div className="ContactGroupContainer">
            <div className="ContactContainerRow">
              <div className="ContactContainerRowTitle">
                <p>Phone: </p>
              </div>
              <div className="ContactPhoneContainer">
                <a href={phonePreFix + "(949) 633-9944"}>
                  <p>(949) 633-9944</p>
                </a>
              </div>
            </div>
            <div className="ContactContainerRow">
              <div className="ContactContainerRowTitle">
                <p>Email: </p>
              </div>
              <div className="ContactEmailContainer">
                <a href={emailPreFix + "info@collegiatesportsadvocate.com"}>
                  <p>info@collegiatesportsadvocate.com</p>
                </a>
              </div>
            </div>
          </div>
        </div>
        {contactButton}
        <ContactForm contact={contact} contactClose={handleContactClose} />
      </div>
    </>
  );
};

export default Contact;
